import { SettingConst } from '../../types';

/**
 * Experiment to quickly test adding verticalized suggestions on the search bar
 * https:www.notion.so/faire/Add-Search-Bar-Verticalized-Dynamic-Text-1292efb5c25a804dab2ec67a21dc05d3
 */
export const ADD_SEARCH_BAR_VERTICALIZED_DYNAMIC_TEXT_241115 =
  'ADD_SEARCH_BAR_VERTICALIZED_DYNAMIC_TEXT_241115' as SettingConst<
    'ADD_SEARCH_BAR_VERTICALIZED_DYNAMIC_TEXT_241115',
    boolean,
    'RETAILER'
  >;
